/**
 * Pending-intent stash — persists an action across the OAuth redirect
 * so a guest who clicks "Add to shortlist" and signs in has that university
 * saved automatically on return, with a confirming toast.
 *
 * Uses sessionStorage: cleared on tab close, per-origin, survives navigation.
 */

const KEY = "wua_pending_shortlist";

export function pushPendingShortlist(university_id, university_name, degree_id = null) {
  try {
    const raw = sessionStorage.getItem(KEY);
    const list = raw ? JSON.parse(raw) : [];
    // De-dup by (university_id, degree_id) — a uni and a specific degree are distinct saves
    const filtered = list.filter((x) => !(x.university_id === university_id && (x.degree_id || null) === (degree_id || null)));
    filtered.push({ university_id, university_name, degree_id: degree_id || null });
    sessionStorage.setItem(KEY, JSON.stringify(filtered));
  } catch {}
}

export function readPendingShortlist() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function clearPendingShortlist() {
  try { sessionStorage.removeItem(KEY); } catch {}
}
